import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatePipe } from '@angular/common'
import { SipKpi } from 'src/app/assabil-sales/models/dtos/sip-kpi';

@Component({
  selector: 'sip-kpi',
  templateUrl: './sip-kpi.component.html',
  styleUrls: ['./sip-kpi.component.scss']
})
export class SipKpiComponent implements OnInit {

  @Input() geoArea    ;
  @Input() sipKpi : SipKpi;

  @Output() onClick        = new EventEmitter<any>();
  @Input() previousPeriod      : string;

  
  constructor(protected datepipe: DatePipe) { }

  ngOnInit() {
  }

  clickDn() {
    if (this.sipKpi.dnProductFamilyCode != "ALL") {
      this.onClick.emit({dnProductFamilyName : this.sipKpi.dnProductFamilyName, dnProductFamilyCode : this.sipKpi.dnProductFamilyCode, geoArea : this.geoArea, kpi : "dnP1"} );
    }
  }
  
  getDnP1(sipKpi : SipKpi) {
    return Math.round((sipKpi.totalCountP1 !=0 ? (sipKpi.invoicedCountP1 * 100 / sipKpi.totalCountP1) : 0));
  }
  getDnP2(sipKpi : SipKpi) {
    return Math.round((sipKpi.totalCountP2 != 0 ? (sipKpi.invoicedCountP2 * 100 / sipKpi.totalCountP2) : 0));
  }
  getDnP3(sipKpi : SipKpi) {
    return Math.round((sipKpi.totalCountP3 != 0 ? (sipKpi.invoicedCountP3 * 100 / sipKpi.totalCountP3) : 0));
  }
  getDnAvgProductFamily(sipKpi : SipKpi){

    return Math.round( ( ((sipKpi.totalCountP1 != 0 ? (sipKpi.invoicedCountP1 * 100 / sipKpi.totalCountP1) : 0)) +
      ((sipKpi.totalCountP2 != 0 ? (sipKpi.invoicedCountP2 * 100 / sipKpi.totalCountP2) : 0)) +
      ((sipKpi.totalCountP3 != 0 ? (sipKpi.invoicedCountP3 * 100 / sipKpi.totalCountP3) : 0)) ) /
      
    ( (sipKpi.invoicedCountP1 != 0 ? 1 : 0) + (sipKpi.invoicedCountP2 != 0 ? 1 : 0) + (sipKpi.invoicedCountP3 != 0 ? 1 : 0) ) )
  }

  dnColorP1(sipKpi : SipKpi) {
    return (this.getDnP1(sipKpi) >= 90 ? "green" : "red");
  }

  dnColorP2(sipKpi : SipKpi) {
    return (this.getDnP2(sipKpi) >= 90 ? "green" : "red");
  }

  dnColorP3(sipKpi : SipKpi) {
    return (this.getDnP3(sipKpi) >= 90 ? "green" : "red");
  }

  dnColorAvgProductFamily(sipKpi : SipKpi) {
    return (this.getDnAvgProductFamily(sipKpi) >= 90 ? "green" : "red");
  }

}